import StandsGrid from "./stands-grid";

export default StandsGrid;